import BroadcastApi from '../../../api/broadcast';
import types from '../../mutation-types';

export const state = {
  templates: [],
  broadcasts: [],
  broadcast_list: [],
  inbox_list: [],
  records: {},
  template_data: {},
  approved_data: {},
  approved_meta: {},
  pending_ids: [],
  pending_meta: {},
  unread_count: {},
  inbox: {},
  meta: {},
  uiFlags: {
    isFetching: false,
    isFetchingRecords: false,
    isUpdating: false,
    isFetchingInbox: false,
    isFetchingApproved: false,
  },
};

export const getters = {
  getTemplates($state) {
    return $state.templates;
  },
  getInboxTemplates($state) {
    return $state.templates;
  },
  getBroadcasts($state) {
    return $state.broadcasts;
  },
  getBroadcastsMeta($state) {
    return $state.meta;
  },
  getUiFlags: $state => $state.uiFlags,
  getBroadcastsList($state) {
    return $state.broadcast_list;
  },
  getBroadcastsRecord($state) {
    return $state.records;
  },
  getInboxList($state) {
    return $state.inbox_list;
  },
  getApprovedMeta($state) {
    return $state.approved_meta;
  },
  getApprovedData($state) {
    return $state.approved_data;
  },
  getPendingMeta($state) {
    return $state.pending_meta;
  },
  getTemplateData($state) {
    return $state.template_data;
  },
  getInbox($state) {
    return $state.inbox;
  },
  getPendingId($state) {
    return $state.pending_ids;
  },
  getUnreadCount($state) {
    return $state.unread_count;
  },
};

export const actions = {
  getTemplates: async ({ commit }, inboxId) => {
    try {
      const { data } = await BroadcastApi.getTemplates(inboxId);
      commit(types.SET_MESSAGE_TEMPLATES, data);
    } catch (error) {
      console.error(error);
    }
  },
  get: async ({ commit }, params) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isFetching: true });
    try {
      const { data } = await BroadcastApi.get(params);
      commit(types.SET_BROADCAST_DATA, data.data);
      commit(types.SET_BROADCAST_META, data.meta);
      commit(types.SET_BROADCAST_UI_FLAG, { isFetching: false });
    } catch (error) {
      commit(types.SET_BROADCAST_UI_FLAG, { isFetching: false });
      console.error(error);
    }
  },
  show: async ({ commit }, params) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isFetchingRecords: true });
    try {
      const { data } = await BroadcastApi.show(params);
      commit(types.SET_BROADCAST_LIST, data.data);
      commit(types.SET_BROADCAST_INBOX, data.inbox);
      commit(types.SET_BROADCAST_TEMPLATE_DATA, data.template_data);
      commit(types.SET_BROADCAST_PENDING_META, data.meta);
      commit(types.SET_BROADCAST_UI_FLAG, { isFetchingRecords: false });
    } catch (error) {
      commit(types.SET_BROADCAST_UI_FLAG, { isFetchingRecords: false });
      console.error(error);
    }
  },

  getApproved: async ({ commit }, params) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isFetchingApproved: true });
    try {
      const { data } = await BroadcastApi.getApproved(params);
      commit(types.SET_BROADCAST_APPROVED_DATA, data.data);
      commit(types.SET_BROADCAST_APPROVED_META, data.meta);
      commit(types.SET_BROADCAST_UI_FLAG, { isFetchingApproved: false });
    } catch (error) {
      commit(types.SET_BROADCAST_UI_FLAG, { isFetchingApproved: false });
      console.error(error);
    }
  },

  getPendingId: async ({ commit }, params) => {
    try {
      const { data } = await BroadcastApi.getPending(params.template_name);
      commit(types.SET_BROADCAST_PENDING_IDS, data.ids);
    } catch (error) {
      console.error(error);
    }
  },

  update: async ({ commit }, { id, data }) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isUpdating: true });
    try {
      await BroadcastApi.update(id, data);
      commit(types.SET_BROADCAST_UI_FLAG, { isUpdating: false });
    } catch (error) {
      commit(types.SET_BROADCAST_UI_FLAG, { isUpdating: false });
    }
  },

  getInbox: async ({ commit }) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isFetchingInbox: true });
    try {
      const { data } = await BroadcastApi.getInbox();
      commit(types.SET_BROADCAST_INBOX_LIST, data);
      commit(types.SET_BROADCAST_UI_FLAG), { isFetchingInbox: false };
    } catch {
      commit(types.SET_BROADCAST_UI_FLAG, { isFetchingInbox: true });
    }
  },

  getUnreadCount: async ({ commit }) => {
    try {
      const { data } = await BroadcastApi.getUnreadCount();
      commit(types.SET_BROADCAST_UNREAD_COUNT, data);
    } catch {
      console.log('error');
    }
  },

  dispatchBroadcasts: async ({ commit }, { payload, inboxId }) => {
    try {
      const response = await BroadcastApi.dispatch(payload, inboxId);

      return response;
    } catch (error) {
      console.log(error);
    }
  },

  getInboxTemplates: async ({ commit }, inboxId) => {
    try {
      commit(types.RESET_MESSAGE_TEMPLATES);
      const { data } = await BroadcastApi.getInboxTemplates(inboxId);
      commit(types.SET_MESSAGE_TEMPLATES, data);
    } catch (error) {
      console.error(error);
    }
  },
};

export const mutations = {
  [types.RESET_MESSAGE_TEMPLATES]($state) {
    $state.templates = [];
  },
  [types.SET_MESSAGE_TEMPLATES]($state, data) {
    $state.templates = data;
  },
  [types.SET_BROADCAST_DATA]($state, data) {
    $state.broadcasts = data;
  },
  [types.SET_BROADCAST_INBOX_LIST]($state, data) {
    $state.inbox_list = data;
  },
  [types.SET_BROADCAST_META]($state, data) {
    $state.meta = data;
  },
  [types.SET_BROADCAST_APPROVED_META]($state, data) {
    $state.approved_meta = data;
  },
  [types.SET_BROADCAST_APPROVED_DATA]($state, data) {
    $state.approved_data = data;
  },
  [types.SET_BROADCAST_LIST]($state, data) {
    $state.broadcast_list = data;
  },
  [types.SET_BROADCAST_RECORDS]($state, data) {
    $state.records = data;
  },
  [types.SET_BROADCAST_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_BROADCAST_INBOX]($state, data) {
    $state.inbox = data;
  },
  [types.SET_BROADCAST_TEMPLATE_DATA]($state, data) {
    $state.template_data = data;
  },
  [types.SET_BROADCAST_PENDING_META]($state, data) {
    $state.pending_meta = data;
  },
  [types.SET_BROADCAST_PENDING_IDS]($state, data) {
    $state.pending_ids = data;
  },
  [types.SET_BROADCAST_UNREAD_COUNT]($state, data) {
    $state.unread_count = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
